import React from 'react';
import { useDidMount, useTranslation } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { ComponentInfo, PdfViewerDrawer } from '@components';
import { avatarLogoBcp } from '@icons';
import { useDrawer, useFetchDocument } from '@hooks';
import { Avatar, Box, Link, Typography, WidgetCard } from '@bcp-nextgen-dx-component-factory/accolade-design-system';
import { rem } from '@helpers';
import { useHasSelectedPremiumSolution } from '@store';

export const EstablishmentAssistanceInsurancePlaceholder: React.FC = () => {
	const t = useTranslation();
	const establishmentAssistanceInsuranceDrawerName = 'establishmentAssistanceInsurance';
	const { show: showPdfDrawer } = useDrawer(establishmentAssistanceInsuranceDrawerName);
	const hasSelectedPremiumSolution = useHasSelectedPremiumSolution();

	const docPremium = t('solutions.document.insurance.premium.id');
	const doc = t('solutions.document.insurance.id');

	let docContent = doc;

	if (hasSelectedPremiumSolution) {
		docContent = docPremium;
	}

	const { base64InsuranceDocument: base64Terms, fetchInsuranceDocument } = useFetchDocument({
		reference: docContent,
	});

	const handleOnClickShowDocument = () => {
		showPdfDrawer();
	};

	useDidMount(() => {
		fetchInsuranceDocument();
	});

	return (
		<ComponentInfo name="EstablishmentAssistanceInsurancePlaceholder">
			<Box styles={{ marginTop: rem(20), width: '100%' }}>
				<WidgetCard
					appearance="tertiary"
					innerContainerProps={{ width: '100%', flexGrow: 1 }}
					container={{ width: '100%', margin: 0 }}
				>
					<Box styles={{ padding: '8px', justifyContent: 'space-between', width: '100%' }}>
						<Box styles={{ flexGrow: 1 }}>
							<Box
								styles={{
									flexShrink: 0,
									height: '100%',
									alignItems: 'center',
								}}
							>
								<Avatar
									content={{
										image: avatarLogoBcp,
										type: 'svg',
									}}
									backgroundColor="transparent"
									size="large"
								/>
							</Box>
							<Box
								styles={{
									height: '100%',
									flexDirection: 'column',
									justifyContent: 'center',
									flexGrow: 1,
									margin: '0 16px',
								}}
							>
								<Typography appearance="body-100-03">
									{t('solutions.document.insurance.label')}
								</Typography>
							</Box>
							<Box
								styles={{
									flexShrink: 0,
									height: '100%',
									alignItems: 'center',
								}}
							>
								<Link
									size="small"
									onPress={handleOnClickShowDocument}
									middleContent={t('general.document.actions.consult')}
								/>
							</Box>
						</Box>
					</Box>
				</WidgetCard>
				{base64Terms && (
					<PdfViewerDrawer
						title={t('solutions.document.insurance.label')}
						subtitle={t('general.pdfViewer.insurance')}
						base64={base64Terms}
						drawerUniqueName={establishmentAssistanceInsuranceDrawerName}
						handleOnClickAcceptTerms={() => void 0}
						wasAccepted={true}
					/>
				)}
			</Box>
		</ComponentInfo>
	);
};
